/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Vu Dinh Luan (vdluan@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 13 2024
 **/

import { useCallback } from "react";
import { useTheme } from "@emotion/react";

import { Menu, Typography } from "@/frameworks/designStuff/components";
import { COLOR_PALETTE_LIST } from "@/frameworks/core/commons";
import { useCreateWorkGroup } from "@/frameworks/core/hooks";

import { menuListStyle, menuWrapperStyle } from "../emotion";

export default function ChangeColorPalette({ disabled }: { disabled: boolean }) {
	const theme = useTheme();
	const {
		selectedColorName,
		handlers: { handleSelectedColorName }
	} = useCreateWorkGroup();

	const handleClick = useCallback((event: React.MouseEvent<HTMLLIElement>) => {
		const name = event.currentTarget.dataset["name"] as keyof Colors;
		handleSelectedColorName(name);
	}, []);

	return (
		<div css={menuWrapperStyle}>
			<Menu.List css={menuListStyle} maxHeight="123px">
				{COLOR_PALETTE_LIST.map((item: DesignStuff.WorkGroup.ColorList) => (
					<Menu.Color
						key={item}
						color={`${item}`}
						onClick={handleClick}
						disabled={disabled}
						data-name={`${item}_50_100`}
						selected={`${item}_50_100` === selectedColorName}
					>
						<Typography.p typoSize="Body5_SB" style={{ color: theme.colors[`${item}_10_100`] }}>
							A
						</Typography.p>
					</Menu.Color>
				))}
			</Menu.List>
		</div>
	);
}
